import { BaseControlBehaviour } from '../BaseControlBehaviour';
export interface IComponentController {
    load(element: HTMLElement, config: any);
}

export class ComponentBehavior extends BaseControlBehaviour {
    private _defaultConfig = {
        controller: null,
    };
    constructor() {
        super('component');
    }

    protected getControllerClass(controllerClass: string) {
        return eval(controllerClass);
    }
    protected installBehaviour(element: HTMLElement): void {
        const config = Utils.getObjectByAttributes(
            this.tag,
            element,
            null,
            $.extend(true, {}, this._defaultConfig)
        );
        if (config.controller) {
            const controllerClass = this.getControllerClass(config.controller);
            const controller: IComponentController = new controllerClass();
            $(element).data('controller', controller);
            controller.load(element, config);
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ComponentBehavior = ComponentBehavior;
